/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const handshake = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.158 10.474-3.21.613m-.445-4.26-2.158.712a.716.716 0 0 1-.874-.38.724.724 0 0 1 .33-.952l2.09-1.05a1.458 1.458 0 0 1 1.157-.068l3.095 1.132M2.826 10.479h1.522l2.185 2.449A.835.835 0 0 0 8 12.383V12m0 0 .109.043a1.03 1.03 0 0 0 1.413-.956M8 12l-.609-.608m2.131-.305h.304a.913.913 0 0 0 .73-1.46L8.605 7.123m.918 3.963-.913-.913M7.12 6.046l-.223-.184a1.307 1.307 0 0 0-1.26-.16L2.866 6.81M1 5.751h1.244a.598.598 0 0 1 .623.57v3.993a.598.598 0 0 1-.623.57H1m14 0h-1.244a.598.598 0 0 1-.623-.57V6.32a.598.598 0 0 1 .623-.57H15"
    />
  </svg>
)
export default handshake
